import React from 'react';
import { Box, Typography, Checkbox, FormControlLabel, Stack, Button, RadioGroup, Radio } from '@mui/material';
import { useAccounts } from './Context';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export const AccountsFilter = props => {
  const { setFiltersParams, choices } = useAccounts();

  const [filters, setFilters] = React.useState({
    groups: [],
    is_active: []

  });

  const resetFilters = () => {
    setFilters({
      groups: [],
      is_active: []
    });
  };

  const handleChangeArray = (value, name) => {
    if (filters[name].includes(value)) {
      setFilters(prev => ({ ...prev, [name]: prev[name].filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, [name]: [...prev[name], value] }));
    }
  };

  const handleChangeAll = (e, name) => {
    if (e.target.checked) {
      setFilters({ ...filters, [name]:
        // nazwy musza odpowiadać początkowi identifier checboxitems
        ['staff', 'managers'] });
    } else {
      setFilters({ ...filters, [name]: [] });
    }
  };


  const handleChangeGroups = value => {
    if (filters.state.includes(value)) {
      setFilters(prev => ({ ...prev, state: prev.state.filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, state: [...prev.groups, value] }));
    }
  };

  React.useEffect(() => {
    const params = new URLSearchParams();

    for (const property in filters) {
      if (filters.hasOwnProperty(property) && filters[property] !== null && filters[property] !== '') {
        if (Array.isArray(filters[property])) {
          filters[property].forEach(value => params.append(property, value));
        } else {
          params.append(property, filters[property]);
        }
      }
    }


    setFiltersParams(params.toString());

  }, [filters]);

  return <Box sx = {{ width: '95%' }}>
    <Stack direction="row" justifyContent="space-between" alignItems="baseline">
      <Typography variant="h6" sx={{ mb: 2 }}>Filtry</Typography>
      <Button onClick={resetFilters}>Resetuj</Button>
    </Stack>      <TreeView
      defaultExpanded={['3']}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      defaultEndIcon={null}
    >
      <TreeItem nodeId="1" label={ <FormControlLabel
        label="Grupy"
        control={
          <Checkbox
            onChange={e => handleChangeAll(e, 'groups')}
            onClick={e => e.stopPropagation()}
            checked={filters.groups.length === 2}
            indeterminate={filters.groups.length < 2 && filters.groups.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          <FormControlLabel
            key={'staff'}
            label={'Pracownik'}
            control={<Checkbox
              checked={filters.groups.includes('staff')}
              onChange={() => handleChangeArray('staff', 'groups')}
            />}
          />
          <FormControlLabel
            key={'managers'}
            label={'Kadra zarządzająca'}
            control={<Checkbox
              checked={filters.groups.includes('managers')}
              onChange={() => handleChangeArray('managers', 'groups')}
            />}
          />
        </Stack>
      </TreeItem>
      <TreeItem nodeId="2" label={ <FormControlLabel
        label="Status konta"
        control={
          <Checkbox
            onChange={e => handleChangeAll(e, 'is_active')}
            onClick={e => e.stopPropagation()}
            checked={filters.is_active.length === 2}
            indeterminate={filters.is_active.length < 2 && filters.is_active.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          <FormControlLabel
            key={'active'}
            label={'Aktywne'}
            control={<Checkbox
              checked={filters.is_active.includes('active')}
              onChange={() => handleChangeArray('active', 'is_active')}
            />}
          />
          <FormControlLabel
            key={'not_active'}
            label={'Nieaktywne'}
            control={<Checkbox
              checked={filters.is_active.includes('not_active')}
              onChange={() => handleChangeArray('not_active', 'is_active')}
            />}
          />
        </Stack>
      </TreeItem>
    </TreeView>
  </Box>;

};

export default AccountsFilter;
